import { NoteWithCourseInfo } from './notesService';

const NOTES_CACHE_KEY = 'userNotesCache';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

export interface NotesCache {
    userId: string;
    notes: NoteWithCourseInfo[];
    timestamp: number;
    version: string; // For cache invalidation if data structure changes
}

export const getCachedNotes = (userId: string): NotesCache | null => {
    try {
        const cached = localStorage.getItem(NOTES_CACHE_KEY);
        if (!cached) return null;

        const parsedCache: NotesCache = JSON.parse(cached);

        // Validate cache
        if (parsedCache.userId !== userId) return null;
        if (Date.now() - parsedCache.timestamp > CACHE_DURATION) return null;
        if (parsedCache.version !== '1.0') return null;

        return parsedCache;
    } catch (error) {
        console.error('Error reading cache:', error);
        return null;
    }
};

export const setCachedNotes = (userId: string, notes: NoteWithCourseInfo[]) => {
    try {
        const cache: NotesCache = {
            userId,
            notes,
            timestamp: Date.now(),
            version: '1.0'
        };

        localStorage.setItem(NOTES_CACHE_KEY, JSON.stringify(cache));
    } catch (error) {
        console.error('Error setting cache:', error);
        // Handle quota exceeded error
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            localStorage.removeItem(NOTES_CACHE_KEY);
        }
    }
};

export const clearNotesCache = () => {
    localStorage.removeItem(NOTES_CACHE_KEY);
}; 